<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <form @submit.prevent="submit" class="card-body" novalidate>
        <div class="row">
          <div class="col-md-6">
            <label class="form-control-label" for="holdingCompanyTitle">شرکت والد</label>
            <treeselect v-model="parentId" :multiple="false" :placeholder="parentTitle ?? 'بدون والد'" :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label required" for="title">نام شرکت</label>
            <input class="form-control" type="text" id="title" name="title" v-model.trim="title" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="phone">تلفن شرکت</label>
            <input class="form-control" type="text" id="phone" name="phone" v-model.trim="phone" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="companyCode">کد سازمانی</label>
            <input class="form-control" type="number" id="companyCode" name="companyCode" v-model="companyCode" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="maxActiveUsers">حداکثر کاربران فعال</label>
            <input class="form-control" type="number" id="maxActiveUsers" name="maxActiveUsers" v-model="maxActiveUsers" />
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="expirationDate">تاریخ پایان اعتبار شرکت</label>
            <custom-date-picker :selectedDate="expirationDate" @update:selectedDate="setDate" />
          </div>
          <div class="col-md-4">
            <label class="form-control-label required" for="countryTitle">کشور</label>
            <vue-select v-model="country" :options="countries" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-4">
            <label class="form-control-label required" for="provinceTitle">استان</label>
            <vue-select v-model="province" :options="provinces" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-4">
            <label class="form-control-label required" for="countyTitle">شهر</label>
            <vue-select v-model="county" :options="counties" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div>
            <label class="form-control-label" for="address">آدرس شرکت</label>
            <textarea class="form-control" id="address" name="address" v-model.trim="address" />
          </div>
        </div>
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <div>
          <button class="btn bg-gradient-success mb-0" type="submit">ثبت</button>
          <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/Company/Company-service.js';
import AddressService from '@/services/Address/Address-service.js';
import { maxLength, helpers, requiredIf, required, minValue, not, sameAs } from '@vuelidate/validators';
import Treeselect from '@cholakovdev/vue3-treeselect';
import CustomDatePicker from '../components/CustomDatePicker.vue';
import CustomerService from "@/services/Company/Customer-service";
import { mapMutations } from "vuex";

export default {
  components: { Treeselect, CustomDatePicker },
  data() {
    return {
      v: this.$useVuelidate(),
      id: null,
      title: '',
      phone: '',
      country: {},
      countryId: null,
      province: {},
      provinceId: null,
      county: {},
      countyId: null,
      address: '',
      companyCode: null,
      companies: [],
      countries: [],
      provinces: [],
      counties: [],
      parentId: null,
      parentTitle: null,
      maxActiveUsers: null,
      expirationDate: null,
      isNew: true,
      firstChange: false
    };
  },
  watch: {
    countries(countries){
      if(this.isNew & countries != null & countries.length > 0){
        this.country = countries[countries.findIndex((value) => value.id == 3)];
      }
    },
    country(country) {
      if (country) {
        this.getProvinces();
        this.countryId = country.id;
        this.province = {};
      }
      else {
        this.provinces = [];
        this.province = {};
        this.countryId = null;
      }
    },
    province(province) {
      if (province) {
        this.getCounties();
        this.provinceId = province.id;
        this.county = {};
      }
      else {
        this.counties = [];
        this.county = {};
        this.provinceId = null;
      }
    },
    county(county) {
      if (county) {
        this.countyId = county.id;
      }
      else {
        this.countyId = null;
      }
    },
    parentId(id) {
      if (this.firstChange) { this.parentTitle = null; }
      this.firstChange = true;
    }
  },
  methods: {
    ...mapMutations(["setCurrentUserInfo"]),
    getCompanies() {
      CompanyService.getCompanyList().then(response => {
        let result = response.data;

        if (!result.success) {
          this.$toast.error(result.message);
        }
        else {
          this.companies = result.data;
        }
      }).catch(e => {
        console.log(e);
      })
    },
    submit() {

      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      let newCompany = {
        Title: this.title,
        Phone: this.phone ?? "",
        Address: this.address ?? "",
        CountyId: this.county.id,
        CompanyCode: this.companyCode > 0 ? this.companyCode : 0,
        ParentId: this.parentId,
        MaxActiveUsers: this.maxActiveUsers,
        ExpirationDate: this.expirationDate,
      };
      let editedCompany = { id: this.id, ...newCompany };

      if (!this.isNew) {
        CompanyService.update(editedCompany).then(response => {
          let result = response.data;

          if (result.success) {
            this.$toast.success(result.message);

            this.getUserCompanies(this.$store.state.currentUserInfo.companyId);
          } else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        CompanyService.createCompany(newCompany).then(response => {
          let result = response.data;

          if (result.success) {
            this.$toast.success(result.message);

            this.getUserCompanies(this.$store.state.currentUserInfo.companyId);
          } else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });

        this.v.$reset();
      }
    },
    getCompany() {
      CompanyService.getCompany(this.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.title = result.data.title;
          this.phone = result.data.phone;
          this.address = result.data.address;
          this.companyCode = result.data.companyCode > 0 ? result.data.companyCode : null;
          this.parentId = result.data.parentId;
          this.parentTitle = result.data.parentTitle;
          this.maxActiveUsers = result.data.maxActiveUsers;
          this.expirationDate = result.data.expirationDate?.toString();
          setTimeout(() => this.county = { id: result.data.countyId, title: result.data.countyTitle }, 20);
          setTimeout(() => this.province = { id: result.data.provinceId, title: result.data.provinceTitle }, 10);
          this.country = { id: result.data.countryId, title: result.data.countryTitle };
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCountries() {
      AddressService.getCountries().then(response => {
        let result = response.data;

        if (result.success) {
          this.countries = result.data;
        }
        else {
          this.toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getProvinces() {
      let countryId = this.country.id;

      AddressService.getProvincesByCountry(countryId).then(response => {
        let result = response.data;

        if (result.success) {
          this.provinces = result.data;
        }
        else {
          this.toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCounties() {
      let provinceId = this.province.id;

      if (provinceId) {
        AddressService.getCountiesByProvince(provinceId).then(response => {
          let result = response.data;

          if (result.success) {
            this.counties = result.data;
          }
          else {
            this.toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    goBack() {
      this.$router.back();
    },
    setDate(date) {
      this.expirationDate = date ? (date.slice(0, 4) + date.slice(5, 7) + date.slice(8, 10)) : null;
    },
    getUserCompanies(companyId) {
      CompanyService.getUserCompanies(companyId).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ companies: result.data });
          this.getUserCustomersByCompany(result.data.allIds);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUserCustomersByCompany(companyIds) {
      CustomerService.getUserCustomersByCompany(companyIds).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ customers: result.data });
        }
        else {
          this.$toast.error(result.message);
        }

        this.$router.back();
      }).catch(e => {
        console.log(e);
      });
    },
  },
  created() {
    this.getCountries();
    this.isNew = this.$route.meta.new;
    this.companies.push(this.$store.state.currentUserInfo.companies);
    if (this.isNew) { this.parentId = this.$store.state.currentUserInfo.companies.id; }

    if (!this.isNew) {
      this.id = this.$route.params.companyId;
      setTimeout(() => this.getCompany(), 100);
    }
  },
  validations() {
    let valObj = {
      parentId: {
        notSameAs: helpers.withMessage('"شرکت والد" معتبر نیست', not(sameAs(parseInt(this.id)))),
      },
      title: {
        required: helpers.withMessage('لطفا "نام شرکت" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "نام شرکت"، 250 کاراکتر است', maxLength(250)),
      },
      phone: {
        //required: helpers.withMessage('لطفا "تلفن شرکت" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "تلفن شرکت"، 50 کاراکتر است', maxLength(50)),
      },
      companyCode: {
        //required: helpers.withMessage('لطفا "کد سازمانی" را وارد کنید', required),
        minValue: helpers.withMessage('مقدار وارد شده برای "کد سازمانی" معتبر نیست', minValue(1)),
      },
      maxActiveUsers: {
        //required: helpers.withMessage('لطفا "حداکثر کاربران فعال" را وارد کنید', required),
        minValue: helpers.withMessage('مقدار وارد شده برای "حداکثر کاربران فعال" معتبر نیست', minValue(0)),
      },
      // expirationDate: {
      //   required: helpers.withMessage('لطفا "تاریخ پایان اعتبار شرکت" را وارد کنید', requiredIf(this.isNew)),
      // },
      countryId: {
        required: helpers.withMessage('لطفا "کشور" را وارد کنید', required),
      },
      provinceId: {
        required: helpers.withMessage('لطفا "استان" را وارد کنید', required),
      },
      countyId: {
        required: helpers.withMessage('لطفا "شهر" را وارد کنید', required),
      },
      address: {
        //required: helpers.withMessage('لطفا "آدرس شرکت" را وارد کنید', required),
        maxLength: helpers.withMessage('حد‌اکثر طول مجاز برای "آدرس شرکت"، 500 کاراکتر است', maxLength(500)),
      },
    };

    return valObj;
  },
}
</script>